/**
 * Deterministic 1-2 letter initials for the card fallback: no avatar means the
 * card has nothing to project, and the character still has to be recognisable
 * on a board full of other tokens.
 */
export function initialsFromName(name: string | undefined | null): string {
  const parts = (name ?? '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  return parts.map((part) => part[0].toUpperCase()).join('');
}
